<div class="left-side">
	<div class="flex items-center mr-3 sticky top-0 bg-white z-20 py-4 border-b">
		<h3>Statement of Adjustments</h3>

		<div class="flex flex-col justify-end ml-3 relative">
			<app-button
				[disabled]="!adjustmentItems?.length || overrideAdjustments"
				btn="primary"
				[icon]="ICON.ADD"
				(clickOutside)="closeAdjustmentList()"
				(click)="toggleAdjustment()"
				size="small"
				id="adjustments-add"
				[testHook]="testHooks.AddButton"
			>
				Add adjustment
			</app-button>
			<app-dropdown-options
				[show]="adjustmentItemsVisible"
				[itemGroups]="[{ items: availableAdjustments }]"
				(onSelect)="addAdjustment($event)"
				xposition="left"
				marginTop="10px"
				class="w-full"
				[testHook]="testHooks.DropdownOptions"
			>
			</app-dropdown-options>
		</div>
	</div>

	<div class="flex items-end justify-between mb-10 mt-5">
		<div class="flex flex-col">
			<div class="mb-3">
				<atomic-switch
					*ngIf="fileType === matterFileTypes.PURCHASE"
					matTooltip="Selecting this checkbox will allow you to enter a new balance due on closing and render adjustments uneditable"
					label="Override balance due on closing"
					[ngModel]="overrideAdjustments"
					(ngModelChange)="overrideAdjustmentsChanged($event)"
					[testHook]="testHooks.OverrideSwitch"
				></atomic-switch>
			</div>
			<div class="mr-2 w-72">
				<app-date-picker
					*ngIf="!overrideAdjustments"
					label="Adjustment date"
					name="date"
					[(ngModel)]="adjustmentDate"
					(ngModelChange)="changed()"
					id="adjustments-date"
					[testHook]="testHooks.DatePicker"
				></app-date-picker>
				<app-input
					*ngIf="overrideAdjustments"
					label="Balance due on closing"
					name="balanceDueOnClosing"
					type="cents"
					[(ngModel)]="balanceDueOnClosing"
					(debounce)="balanceDueOnClosingChanged($event)"
					[testHook]="testHooks.BalanceDueOnClosing"
				></app-input>
			</div>
			<div class="relative">
				<ng-container *ngIf="!overrideAdjustments">
					<span class="absolute text-sm text-red" *ngIf="!closingDate"
						>Closing date not set</span
					>
					<span
						class="absolute text-sm text-grey"
						[@openClose]
						*ngIf="adjustmentDate === closingDate && closingDate"
						>Same as closing date</span
					>
					<span
						class="absolute text-green text-sm cursor-pointer hover:underline"
						*ngIf="adjustmentDate !== closingDate && closingDate"
						[@openClose]
						(click)="setAdjustmentDateToClosingDate()"
						[testHook]="testHooks.DateToClosingSpan"
						>Set to closing date {{ closingDate | date: 'mediumDate' }}</span
					>
				</ng-container>
				<span *ngIf="overrideAdjustments" class="absolute text-sm text-grey"
					>This amount is advanced to the Trust Ledger</span
				>
			</div>
		</div>
	</div>

	<div
		id="adjustments-list"
		class="mr-3 relative"
		cdkDropList
		(cdkDropListDropped)="drop($event)"
	>
		<div
			[class.opacity-10]="overrideAdjustments"
			cdkDrag
			*ngFor="
				let adjustment of adjustmentItems;
				let i = index;
				trackBy: trackByadjustmentId
			"
			class="adjustment mb-4"
			id="{{ adjustment.type }}"
		>
			<div
				class="flex w-full relative flex-1 cursor:pointer justify-between p-2 rounded-md bg-grey-veryLight fabParent hover:border-green-light border"
				(mouseover)="setOnHover(i)"
				(mouseout)="setOnHover(null)"
			>
				<div
					*ngIf="highlightedAdjustment === i"
					class="absolute top-0 left-0 w-full h-full flex justify-center items-center rounded-xl bg-white bg-opacity-80"
					[@fade]
				>
					<app-button
						btn="tertiary"
						[icon]="ICON.EDIT"
						class="text-sm text-green ml-10"
						(click)="
							openDialog(
								adjustment.component,
								adjustment.calculated?.adjustment?.id
							)
						"
						*ngIf="
							!adjustment.requiresDate ||
							(adjustment.requiresDate && adjustmentDate)
						"
						[testHook]="testHooks.DialogButton"
					></app-button>
					<app-button
						*ngIf="adjustment.deletable"
						btn="tertiary"
						[icon]="ICON.DELETE"
						[holdable]="true"
						(onClick)="removeAdjustment(adjustment?.calculated?.adjustment)"
						class="text-sm text-green"
						[testHook]="testHooks.DeleteButton"
					></app-button>
					<app-button
						[icon]="ICON.SORT"
						cdkDragHandle
						*ngIf="adjustment?.reorderable"
						[testHook]="testHooks.SortButton"
					></app-button>
				</div>

				<div class="flex w-full flex-col adjustment-item">
					<div
						class="flex w-full flex-col xl:flex-row xl:justify-between xl:items-center xl:flex-1 flex-wrap"
					>
						<div class="flex flex-row gap-2 items-center order-1">
							<h4
								class="truncate adjustment-title mb-0"
								[testHook]="testHooks.Title"
							>
								{{
									adjustment.nameOverride
										? adjustment.nameOverride
										: adjustment.name
								}}
							</h4>
						</div>

						<div
							class="flex order-3 xl:flex-next-line mt-2 items-center"
							*ngIf="
								adjustment?.calculated?.adjustment?.type ===
									adjustmentTypes.TarionWarranty &&
								showTarionWarrantyAdjustmentWarning
							"
						>
							<atomic-message-bar
								type="warn"
								[shadow]="false"
								[testHook]="testHooks.MessageBar"
							>
								<p>Please adjust selections as per new Sale Price</p>
							</atomic-message-bar>
						</div>

						<div class="flex items-center order-2">
							<ng-container
								*ngIf="
									!adjustment.requiresDate ||
									(adjustment.requiresDate && adjustmentDate)
								"
							>
								<span class="text-xs whitespace-nowrap mr-2">{{
									adjustment?.calculated?.creditAmount > 0
										? 'Credit Vendor'
										: adjustment?.calculated?.creditAmount == 0
											? adjustment?.calculated?.adjustment?.credit ===
												'purchaser'
												? 'Credit Purchaser'
												: 'Credit Vendor'
											: 'Credit Purchaser'
								}}</span>
								<span class="text-xl font-bold">{{
									adjustment?.calculated?.absAmount | centsToDollars
								}}</span>
							</ng-container>
						</div>
					</div>

					<div
						*ngIf="adjustment.requiresDate && !adjustmentDate"
						class="mt-2"
						[@openClose]
					>
						<p class="text-center">
							Adjustments cannot be calculated without an adjustment date
						</p>
					</div>

					<div
						*ngIf="
							adjustment?.calculated?.adjustment?.type ===
								adjustmentTypes.VacantTax &&
							!!!(vacantTaxApplicableJurisdiction$ | async)
						"
						class="mt-2"
						[@openClose]
					>
						<p class="text-center">
							Vacant home tax selections have been changed
						</p>
					</div>
				</div>
			</div>
		</div>
		<div
			*ngIf="overrideAdjustments"
			class="absolute top-0 left-0 inset-0 w-full flex items-center justify-center"
		>
			<div class="w-1/2 flex flex-col item-center justify-center text-center">
				<app-icon [icon]="ICON.LOCK" class="text-2xl"></app-icon>
				<p>Adjustment setting locked when override is enabled.</p>
			</div>
		</div>
	</div>

	<div
		class="flex flex-row justify-end items-center gap-5 mb-5 mr-3"
		[class.opacity-10]="overrideAdjustments"
	>
		<p>Balance due on closing:</p>
		<p class="text-xl font-bold">{{ salePrice | centsToDollars }}</p>
	</div>
</div>

<ng-container
	*ngIf="statementOfAdjustmentsDocSourceIdByMatterType$ | async as sourceId"
>
	<app-documents-word-matter-viewer
		*ngIf="!(useHtmlDocuments$ | async)"
		sourceId="{{ sourceId }}"
	></app-documents-word-matter-viewer>
</ng-container>
<div class="grid min-h-0" *ngIf="useHtmlDocuments$ | async">
	<app-document-matter-viewtor
		class="h-full"
		[sourceId]="fileType === matterFileTypes.SALE ? 'soa' : 'soap'"
	></app-document-matter-viewtor>
</div>
